/**
 * PDP: moves the Clickpost pincode/EDD app block into the quantity +
 * add-to-cart row so it sits on the same line, on desktop only (>= 768px).
 * Below that it's left in its original rendered position/styling.
 *
 * The Clickpost widget is rendered by Shopify as an app block, as a sibling
 * of the product form inside `.product-blocks` - it can't be relocated from
 * Liquid because Shopify's app-block content injection doesn't survive being
 * passed through an assigned variable / nested snippet render. So this moves
 * the already-rendered DOM node once the page (and, if needed, the app's
 * async content) is ready, and undoes the move if the viewport drops below
 * the desktop breakpoint.
 */
(function () {
  var mql = window.matchMedia('(min-width: 768px)');

  function findPincodeBlock(container, form) {
    for (var i = 0; i < container.children.length; i++) {
      var el = container.children[i];
      if (el !== form && el.querySelector && el.querySelector('.clickpost-edd__container')) {
        return el;
      }
    }
    return null;
  }

  function syncLayout() {
    var isDesktop = mql.matches;

    document.querySelectorAll('.product-form[data-has-quantity-selector]').forEach(function (form) {
      var wrapper = form.querySelector('.product-form__quantity-and-buy-buttons-wrapper');
      var container = form.closest('.product-blocks');
      if (!wrapper || !container) return;

      var inlineBlock = wrapper.querySelector('.pdp-pincode-inline-block');

      if (isDesktop) {
        if (inlineBlock) return;

        var pincodeBlock = findPincodeBlock(container, form);
        if (pincodeBlock) {
          pincodeBlock.classList.add('pdp-pincode-inline-block');
          wrapper.appendChild(pincodeBlock);
        }
      } else if (inlineBlock) {
        inlineBlock.classList.remove('pdp-pincode-inline-block');
        if (form.nextSibling) {
          container.insertBefore(inlineBlock, form.nextSibling);
        } else {
          container.appendChild(inlineBlock);
        }
      }
    });
  }

  function init() {
    syncLayout();

    // The Clickpost widget's markup can still be arriving asynchronously
    // after DOMContentLoaded, so keep watching product blocks briefly and
    // sync again as soon as it shows up.
    var containers = document.querySelectorAll('.product-blocks');
    if (containers.length && typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () {
        syncLayout();
      });

      containers.forEach(function (container) {
        observer.observe(container, { childList: true, subtree: true });
      });

      setTimeout(function () {
        observer.disconnect();
      }, 10000);
    }

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', syncLayout);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(syncLayout);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
